import React from 'react';
import { motion } from 'framer-motion';
interface PricingProps {
  title?: string;
  sectionId?: string;
}
export function Pricing({
  title = 'ELEGÍ TU PACK',
  sectionId
}: PricingProps) {
  return <section id={sectionId} className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto scroll-mt-8" data-id="element-160" data-mp="2oj8q5jss05eo">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-4xl md:text-5xl font-black text-center mb-16" data-id="element-161" data-mp="2jknpxkdixlq8">
        {title}
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-162" data-mp="25tsp8vd6iaxq">
        {/* Basic Pack */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-green/20 rounded-3xl p-8 flex flex-col h-full" data-id="element-163" data-mp="20v7mao6jld5l">
          <div className="text-2xl font-black mb-2 flex items-center gap-2" data-id="element-164" data-mp="4s4ab7stylgb">
            <span data-id="element-165" data-mp="9siak3o6wr3s">📘</span> SUPERPACK ABDOMEN PLANO
          </div>
          <p className="text-gray-400 mb-8 font-medium" data-id="element-166" data-mp="9q5q9juym4nk">6 Tomos + 6 Bonos</p>

          <div className="mb-8 flex-grow" data-id="element-167" data-mp="eqtiu9yu6tjw">
            <div className="text-gray-500 line-through text-xl mb-1" data-id="element-168" data-mp="3d97gpojv1ysx">
              ~~$49.000~~
            </div>
            <div className="text-5xl font-black text-white" data-id="element-169" data-mp="3i7irq2lw6fcq">
              $19.990{' '}
              <span className="text-xl text-gray-400 font-bold" data-id="element-170" data-mp="3n7etdv749up4">ARS</span>
            </div>
          </div>

          <motion.a href="https://www.mododigital.shop/cart/45871702114502:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-darker border-2 border-brand-green text-brand-green hover:bg-brand-green hover:text-white font-black text-lg py-4 rounded-xl transition-colors text-center block" data-id="element-171" data-mp="3ryddz6z51ey6">
            → QUIERO MI SUPERPACK AHORA
          </motion.a>
        </motion.div>

        {/* Premium Pack */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border-2 border-brand-green rounded-3xl p-8 flex flex-col h-full relative shadow-[0_0_50px_rgba(168,85,247,0.15)] md:scale-105 z-10" data-id="element-172" data-mp="2w7bh798mq25d">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-darker font-black text-sm px-4 py-1 rounded-full uppercase tracking-wider shadow-lg" data-id="element-173" data-mp="2dgaj0nfc2amv">
            MÁS ELEGIDO
          </div>

          <div className="text-2xl font-black mb-2 flex items-center gap-2" data-id="element-174" data-mp="3ovz5zesl79no">
            <span data-id="element-175" data-mp="9m1gdyu7m93">💎</span> COMBO DIAMANTE ⭐
          </div>
          <p className="text-gray-300 mb-2 font-bold" data-id="element-176" data-mp="5970sphx5wmc">
            6 Tomos + 6 Bonos + Método Cuerpo Fit en Casa
          </p>
          <p className="text-brand-green/80 text-sm mb-8 font-medium" data-id="element-177" data-mp="3ng4vi1u3qox6">
            Tonificá brazos, glúteos y piernas después del abdomen
          </p>

          <div className="mb-8 flex-grow" data-id="element-178" data-mp="3rihxcf5qa2oo">
            <div className="text-gray-500 line-through text-xl mb-1" data-id="element-179" data-mp="j1wmestjczix">
              ~~$69.000~~
            </div>
            <div className="text-5xl font-black text-brand-green" data-id="element-180" data-mp="nyn39id5zz5e">
              $27.990{' '}
              <span className="text-xl text-brand-green/60 font-bold" data-id="element-181" data-mp="a7rzullfqa97">ARS</span>
            </div>
          </div>

          <motion.a href="https://www.mododigital.shop/cart/45871705227462:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-brand-green hover:bg-purple-400 text-white font-black text-lg py-4 rounded-xl shadow-[0_0_20px_rgba(168,85,247,0.4)] transition-colors text-center block" data-id="element-182" data-mp="e8lpbjeizx47">
            → QUIERO EL COMBO DIAMANTE
          </motion.a>
        </motion.div>
      </div>
    </section>;
}